import type { ReactNode } from 'react';
import { Icon } from '../ui/Icon';

/** Confirmation after an email has been sent (password reset, sign-in link). */
export default function AuthSentNotice({ children }: { children: ReactNode }) {
    return (
        <div role="status" className="flex items-start gap-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-status-success/15 text-status-success">
                <Icon name="check" size={18} />
            </span>
            <p className="text-body text-content-secondary">{children}</p>
        </div>
    );
}
